import { jsx as _jsx } from "react/jsx-runtime";
import { useHref, useNavigate } from 'react-router-dom';
import { Button } from './button';
export function ButtonLink({ to, onClick, ...props }) {
    const navigate = useNavigate();
    const href = useHref(to);
    function handleClick(event) {
        event.preventDefault();
        onClick?.(event);
        navigate(to);
    }
    return _jsx(Button, { ...props, onClick: handleClick, href: href });
}
